/* eslint-disable indent,quote-props,no-unused-vars,dot-notation,padded-blocks,no-,no-restricted-syntax */
/**
 * Details Controller file
 * @class
 */

import vasActivationModalTemplate from "../SavedWithSuccessModal.html"

class BillAtTableDetailsController {

    /* @ngInject */

    constructor($log, $q, $timeout, MerchantConfigurationService,
                MerchantVasService, StorageService, $rootScope, ModalFactory,
                TermsService, NewTokenService) {
        const that = this;
        that.currentVasTypeId = MerchantVasService.getVasesTypes()['BILL-AT-TABLE'];
        that.currentWalletId = NewTokenService.getMerchantWalletID();
        that.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
        that.configuration = {
            "enabled": true,
            "invoiceEnabled": true,
            "taxRate": 10,
            "tableNumEnabled": true
        };


      this.showVasConfigurationSuccess = () => {
            const closeModal = () => {
                modal.deactivate();
                $timeout(modal.destroy, 1000);
            };

            const modal = new ModalFactory({
                overlay: true,
                overlayClose: true,
                template: vasActivationModalTemplate,
                class: 'default',
                contentScope: {
                    okFunc: closeModal
                }
            });

            modal.activate();
        };

        that.save = () => {
            MerchantVasService.configureVas(that.configuration, that.currentVas.id).then((ok) => {
                this.configuration = ok.data;
                that.showVasConfigurationSuccess();
            });
        };

        const init = () => {
            var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
            MerchantVasService.getVasByType(that.currentVasTypeId, merchantProfile.business.id)
                .then(
                    (response) => {
                        that.currentVas = response.data;
                        that.configuration = that.currentVas.configuration;
                    },
                    (error) => {
                        alert("error retrieving the vas!");
                    }
                );
        };

        that.$onInit = init;
    }
}

export default BillAtTableDetailsController;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/billAtTable/billAtTable.controller.js
 **/